import { OrderEventListResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Icon } from "../../../../components";
import { ActionPanel } from "../../../../components/actionPanel/ActionPanel";

export function OrderEventsEditType({
  event,
}: {
  event: OrderEventListResponseType[number];
}): ReactElement {
  const lastWord = event.message.split(" ").slice(-1)[0];
  const isOrderItemChangeType = [
    "decreased",
    "increased",
    "added",
    "removed",
  ].includes(lastWord?.toLowerCase() ?? "");

  const getMessage = () => {
    if (isOrderItemChangeType && lastWord) {
      const splitMessage = event.message.split(lastWord);
      return (
        <p>
          {splitMessage} <strong>{lastWord}</strong>
        </p>
      );
    }

    return <p>{event.message}</p>;
  };

  return (
    <ActionPanel title={""} className={"ml-[10px] p-3"}>
      <div className="flex flex-col gap-2">
        <div className="flex w-full flex-row justify-between">
          <div className="flex flex-row gap-2">
            <Icon icon={"PENCIL"} />
            {getMessage()}
          </div>
        </div>
      </div>
    </ActionPanel>
  );
}
